module.exports = __webpack_public_path__ + "static/vitalis-c9ddc92d67f0b6864839ad290203db2e.svg";